import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "37%",
  left: "59%",
  transform: "translate(-50%, -50%)",
  width: 453,
  background: theme.palette.custom.virtualSuccess,
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,
  outline: "none",
  padding: "19px 24px",

  [theme.breakpoints.down("md")]: {
    width: 430,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  [theme.breakpoints.down("xs")]: {
    width: 270,
  },
}));

export const StyledUl = styled("ul")(() => ({
  marginLeft: "20px",
}));
export const StyledTypographyLiTopic = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.virtualDescription,
}));

export const StyledLiTop = styled("li")(() => ({
  color: "black",
}));

export const StyledBoxLi = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.white,
  padding: "10px 20px",
  border: "1px solid #FFEDD9",
  borderRadius: theme.borderRadius.radius.wallet,
  maxHeight: 450,
  overflowY: "auto",
  scrollbarColor: `${theme.palette.custom.warning} ${theme.palette.custom.white}`,
  scrollbarWidth: "thin",
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  color: theme.palette.custom.virtualTitle,
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
  marginBottom: "16px",
}));
